<template lang="html">
    <entity-page v-loader-overlay="progress" id="page__paymentmethod">
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
        <z-input
            name="name" id="name" label="Название способа оплаты" v-bind:required="true" v-model="method.name" 
            v-validate="'required|min:1|max:255'" v-bind:error="errors.first('name')" data-vv-name="name" v-bind:data-vv-as="' '"
        ></z-input>
        <z-select
            name="type" id="type" label="Тип способа оплаты" v-bind:required="true" v-model="method.type"
            v-validate="'required'" v-bind:error="errors.first('type')"  data-vv-name="type" v-bind:data-vv-as="' '"
            v-bind:disabled="true"
        >
            <option value="" selectd disabled>Не установлен</option>
            <option v-for="type in Object.values(types)" v-bind:value="type.value">{{type.name}}</option>
        </z-select>

        <z-select
            name="forwarding_access" id="forwarding_access" label="Экспедирование груза при наличии задолженности по плательщику" v-bind:required="true" v-model="method.forwarding_access"
            v-validate="'required'" v-bind:error="errors.first('forwarding_access')"  data-vv-name="forwarding_access" v-bind:data-vv-as="' '"
        >
            <option value="" selectd disabled>Не установлено</option>
            <option v-bind:value="1">Разрешено</option>
            <option v-bind:value="2">Запрещено</option>
        </z-select>

        <z-check
            label="Автивен" name="active" id="active"
            v-model="method.active" v-bind:value="1"
            v-bind:error="errors.first('active')" v-bind:data-vv-name="('active')" v-bind:data-vv-as="' '"
        ></z-check>
        <z-check
            label="Является ли статус публичным"
            id="public" v-model="method.public" v-bind:value="1"
            v-bind:error="errors.first('public')" data-vv-name="public" v-bind:data-vv-as="' '"
        ></z-check>
  </entity-page>
</template>
<script>
    import ZInput  from '@/components/ZInput';
    import ZCheck  from '@/components/ZCheck';
    import ZSelect from '@/components/ZSelect';
    import ZCheckList   from '@/components/ZCheckList';
    import EntityPage   from '@/components/EntityPage.vue';
    import ZIconButton  from '@/components/ZIconButton';
    export default {
        components: {ZInput, ZSelect, ZCheck, ZCheckList, EntityPage, ZIconButton},
        data() {
            return {
                method: {},
                defaultMethod: {
                    id: null,
                    name: null,
                    type: null,
                    forwarding_access: null,
                    active: 0,
                    public: 0
                },
                types: {
                    1: {
                        name: 'Онлайн оплата',
                        value: 1,
                    },
                    2: {
                        name: 'Оплата по счёту',
                        value: 2,
                    },
                    3: {
                        name: 'Наличными с чеком',
                        value: 3,
                    },
                    4: {
                        name: 'Наличными без чека',
                        value: 4,
                    },
                    5: {
                        name: 'По карте',
                        value: 5,
                    },
                    6: {
                        name: 'СПБ',
                        value: 6,
                    }                    
                }
            }
        },
        created() {
            this.init();
            this.listeners();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            async init() {
                this.$store.commit('openRightPanel');
                if (this.$route.params.method_id != 'new') await this.getMethod();
                else this.method = Object.assign({}, this.defaultMethod);

                if (this.$route.params.method_id != 'new') this.$store.commit('setTitle', 'Способы оплаты | ' + this.method.name);
                else this.$store.commit('setTitle', 'Способы оплаты | Новый способ оплаты');
            },
            /**
             * Возвращает пользователя на предидущую страницу
             */
            back() {
                this.$router.push({name: 'PaymentMethods', query: this.$route.query});
            },
            /**
             * Обновление формы при получении push уведомления
             */
            listeners() {
                this.$root.$on('update-method-form', id => {
                    if (parseInt(id) === parseInt(this.$route.params.method_id)) this.init();
                });
            },
            /**
             * Изменение метода
             */
            putMethod() {
                this.$store.commit('showProgressBar', 'load-method-card');
                this.$store.dispatch('cost/putPaymentMethod', this.method).then(r => {
                    if (!r) return;
                    this.init();
                    this.$root.$emit('reload-table', 'paymentmethods')
                }).finally(() => this.$store.commit('hideProgressBar', 'load-method-card'));
            },
            /**
             * Добавление метода
             */
            postMethod() {
                this.$store.commit('showProgressBar', 'load-method-card');
                this.$store.dispatch('cost/postPaymentMethod', this.method).then(r => {
                    if (!r) return;
                    this.$root.$emit('reload-table', 'paymentmethods')
                    this.$router.replace({name: 'PaymentMethod', params: {method_id: r.id}});
                }).finally(() => this.$store.commit('hideProgressBar', 'load-method-card'));
            },
            /**
             * Сохранение метода
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    let data = Object.assign({}, this.method);
                    
                    data.active = parseInt(data.active);
                    data.public = parseInt(data.public);

                    if (this.method.id != 'new') this.putMethod();
                    else this.postMethod();
                });
            },
            /**
             * Получение методов
             */
            getMethod() {
                this.$store.commit('showProgressBar', 'load-method-card');
                return this.$store.dispatch('cost/getPaymentMethod', this.$route.params.method_id).then(method => {
                    if (!method) return;
                    method.active = parseInt(method.active);
                    method.public = parseInt(method.public);
                    this.method = Object.assign({}, method);
                    return this.method;
                }).finally(() => this.$store.commit('hideProgressBar', 'load-method-card'));
            },
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-method-card'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
        },
        watch: {
            '$route.params.method_id'() {
                this.init();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// PaymentMethod.vue?15eb7bd0